<script setup>
/** @typedef {import('@/models/Todo').Todo} Todo */
import RemoveButton from './RemoveButton.vue';

// 親から渡されたデータ
/** @type {{ deletedTodos: Todo[]}} */
defineProps({
  deletedTodos: Array,
});

//MEMO:emitとは発する・吹く・吐くなどの意味
//removeイベントを親に通知
const emit = defineEmits(['remove']);

// 子から受け取ったclickを受け取り
// todoを親に渡す
function remove(todo, isUndo = false) {
  // emitの引数で親に値を渡す
  emit('remove', todo, isUndo);
}
</script>
<template>
  <ul class="border-4 border-gray-500 rounded-sm p-4">
    <li v-for="todo in deletedTodos" :key="todo.todoId" class="grid grid-cols-12 my-1 items-start">
      <!-- todo本文 -->
      <span class="col-span-11 items-start">
        {{ todo.todo }}
      </span>
      <!-- 削除取り消しボタン -->
      <RemoveButton label="+" @click="remove(todo, true)" />
    </li>
  </ul>
</template>
